import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RuiIconChevronDown } from "@/lib/icons";
import { RuiButton } from "../button";
import "./menu-button.script";
export function RuiMenuButtonTrigger({
  children,
  class: className,
  variant = "filled",
  size = "md",
  ...props
}) {
  return /* @__PURE__ */jsxs(RuiButton, {
    ...props,
    variant,
    size,
    "data-ref": "trigger",
    class: cx("rui-menu-button__trigger", className),
    "aria-haspopup": "menu",
    children: [children, /* @__PURE__ */jsx(RuiIconChevronDown, {
      class: "rui-menu-button__chevron"
    })]
  });
}
export function RuiMenuButtonContent({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "menu",
    class: cx("rui-menu-button__menu", "rui-popover", "rui-floating", className),
    role: "menu",
    children
  });
}
export function RuiMenuButtonItem({
  children,
  value,
  disabled,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    type: "button",
    class: cx("rui-menu-button__item", className),
    role: "menuitem",
    "data-value": value,
    "aria-disabled": disabled ? "true" : void 0,
    disabled,
    tabIndex: -1,
    children
  });
}
export function RuiMenuButton({
  trigger,
  items,
  children,
  class: className,
  ...props
}) {
  if (trigger == null && items == null) {
    return /* @__PURE__ */jsx("rui-menu-button", {
      ...props,
      class: cx("rui-menu-button", className),
      children
    });
  }
  return /* @__PURE__ */jsxs("rui-menu-button", {
    ...props,
    class: cx("rui-menu-button", className),
    children: [/* @__PURE__ */jsx(RuiMenuButtonTrigger, {
      children: trigger
    }), /* @__PURE__ */jsx(RuiMenuButtonContent, {
      children: items?.map(item => /* @__PURE__ */jsx(RuiMenuButtonItem, {
        value: item.value,
        disabled: item.disabled,
        children: item.label
      }))
    })]
  });
}